import { useContext } from 'react';
import {ReactComponent as ShoppingIcon} from '../../assets/shopping-bag.svg'
import './cart-icon-scss/cart-icon.styles.css';
import { CartDropdownContext } from '../../contexts/cart-dropdown.context';

const CartIcon = () => {
    const {isCartOpen, setIsCartOpen, cartCount} = useContext(CartDropdownContext);
    const toggleIsCartOpen = () => {
        return(
            setIsCartOpen(!isCartOpen)
        )
    }
    return(
        <div className='cart-icon-container' onClick={toggleIsCartOpen}>
            <ShoppingIcon className = 'shopping-icon'/>
            <span className='item-count'>
                {cartCount}
            </span>
        </div>
    )
}

export default CartIcon;